import { z } from 'zod';
import { codigoConsecutivoSchema } from '../codigo-consecutivo';

export const companySchema = z.object({
  codigo: codigoConsecutivoSchema,
  nombre: z
    .string()
    .min(1, 'Ingrese el nombre')
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre no puede superar 100 caracteres'),
  nit: z
    .string()
    .min(1, 'Ingrese el NIT')
    .min(5, 'El NIT debe tener al menos 5 caracteres')
    .max(20, 'El NIT no puede superar 20 caracteres'),
  ciudad: z
    .string()
    .min(1, 'Ingrese la ciudad')
    .min(2, 'La ciudad debe tener al menos 2 caracteres')
    .max(100, 'La ciudad no puede superar 100 caracteres'),
  correoContacto: z
    .string()
    .min(1, 'Ingrese el correo de contacto')
    .email('Ingrese un correo válido'),
  notasPdf: z.string().max(500, 'Las notas no pueden superar 500 caracteres').optional(),
});

export type CompanyFormValues = z.infer<typeof companySchema>;
